import { PageType } from "@/components/Joyspace/const";
import { IContextRender } from "../components/List/ContextMenu";
import { ICategory, IPage } from "../components/List/types";
import { PermissionEnum } from "../permissions";

import batchMove from "./batch.move";
import batchDownload from "./batch.download";
import batchRemove from "./batch.remove";
import batchCopy from "./batch.copy";
import { isFocusEnv } from "@/utils";
export { default as api } from "../api";

type IContextParameters<T> = Parameters<IContextRender<T>>;

export type IAddCallback = (
  o: IContextParameters<(ICategory | IPage)[]>[1],
  isAllow: boolean,
  isTeam?: boolean,
  currentRouterInfo?: any,
  type?: string
) => Parameters<IContextParameters<ICategory | IPage>[0]> | undefined;

export enum Names {
  "RECENT" = "RECENT",
  "SHARES" = "SHARES",
  "MY_SHARE" = "MY_SHARE",
  "MY_SPACE" = "MY_SPACE",
  "TEAM_SPACE" = "TEAM_SPACE",
  "ZHUANBAN" = "ZHUANBAN",
  "GROUP" = "GROUP",
  "MY_SPACE_FOLDER" = "MY_SPACE_FOLDER",
  "MY_SPACE_PAGE" = "MY_SPACE_PAGE",
  "TEAM_SPACE_FOLDER" = "TEAM_SPACE_FOLDER",
  "TEAM_SPACE_PAGE" = "TEAM_SPACE_PAGE",
  "COLLECTIONS_PAGE" = "COLLECTIONS_PAGE",
  "COLLECTIONS_FOLDER" = "COLLECTIONS_FOLDER",
  "TRASHES" = "TRASHES"
}

export const PageRouteName = Names;

function checkPermissions(folderPermissionsEnum: any, pagePermissionsEnum: any, batchData: any[]) {
  for (const item of batchData) {
    const onePermissions = item.permissions || [];
    const optionPermission =
      typeof item.page_type === "undefined" ? folderPermissionsEnum : pagePermissionsEnum;
    if (!onePermissions.includes(optionPermission)) {
      return false;
    }
  }
  return true;
}
function batch(
  name?: keyof typeof Names,
  currentRouterInfo?: any,
  groupInfo = {}
): IContextRender<(ICategory | IPage)[]> {
  return (addOption, props: any) => {
    // console.log(props, 'propspropspropsprops====>');
    const _props = { ...props, ...groupInfo };
    const option = (cb: IAddCallback, isAllow = true) => {
      console.log("isAllow111", isAllow);
      const res = cb(_props, isAllow, name === Names.TEAM_SPACE, currentRouterInfo, name);
      res && addOption.apply(null, res);
    };
    const hasPage = [...props.data].some((item: any) => item.page_type !== 6);
    isFocusEnv() &&
      !hasPage &&
      option(
        batchDownload,
        name === Names.MY_SPACE ||
          checkPermissions(PermissionEnum.FOLDER_VIEW, PermissionEnum.PAGE_VIEW, props.data)
      );
    option(
      batchCopy,
      name === Names.MY_SPACE ||
        checkPermissions(PermissionEnum.FOLDER_COPY, PermissionEnum.PAGE_COPY, props.data)
    );
    option(
      batchMove,
      name === Names.MY_SPACE ||
        checkPermissions(PermissionEnum.FOLDER_MOVE, PermissionEnum.PAGE_MOVE, props.data)
    );
    option(
      batchRemove,
      name === Names.MY_SPACE ||
        checkPermissions(PermissionEnum.FOLDER_REMOVE, PermissionEnum.PAGE_REMOVE, props.data)
    );
  };
}

export default {
  batch
};
